module.exports = function() {
  return new Worker(__webpack_public_path__ + "ceafe83afea178a522ca.worker.js");
};